var map = {
	"./achievements.svg": 96,
	"./address_image.svg": 172,
	"./andres.png": 173,
	"./blogs_image.svg": 174,
	"./cinema.svg": 97,
	"./climbing.svg": 175,
	"./climbing1.svg": 98,
	"./coding.svg": 99,
	"./contactMail.png": 176,
	"./data_science.svg": 177,
	"./developerActivity.svg": 178,
	"./dragonbab.jpeg": 179,
	"./eating.svg": 100,
	"./education.svg": 180,
	"./experience.svg": 181,
	"./feelingProud.svg": 182,
	"./fullstack.svg": 183,
	"./gaming.svg": 101,
	"./github_logo.png": 184,
	"./google_logo.png": 185,
	"./itamconstruye.jpg": 186,
	"./itamlogo.png": 187,
	"./manOnTable.svg": 188,
	"./microsoft_logo.png": 189,
	"./moon.svg": 190,
	"./portfolio.gif": 191,
	"./programmer.svg": 192,
	"./projects_image.svg": 193,
	"./rdt.png": 194,
	"./reading.svg": 102,
	"./skill.svg": 95,
	"./soccer.svg": 103,
	"./sports.svg": 104,
	"./sun.svg": 195,
	"./ui_ux_design.svg": 196,
	"./unamlogo.png": 197
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55;